import React from "react";
import styles from "./benefitBlock.module.css";

const BenefitBlock = ({ icon, content }) => {
  return (
    <div className={styles.benefit}>
      {icon}
      <p><strong>{content}</strong></p>
    </div>
  );
};

export default BenefitBlock;
